import { CloudImageRowProps } from '@components/CloudImageRow';

export const SECTION_ID = 'Rachel_Zoe_Head_To_Toe_Wedding';
export const AUTO_PLAY_INTERVAL = 3000;
export const SLIDE_SPEED = 500;
export const EASING = 'easeSinInOut';

export const groupImages: CloudImageRowProps[] = [
  [
    {
      circle: true,
      text: {
        content: '“It’s been a dream working with Joy on this partnership”',
        color: 'neutra6',
        backgroundColor: 'humana1',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
    {
      image: {
        url: 'rachel zoe/val-props-carousel/2-registry/rz-shaker.jpg',
      },
      sm: {
        width: 436,
        height: 329,
      },
      belowSm: {
        width: 220,
        height: 166,
      },
    },
    {
      text: {
        content: '“I encourage couples to plan their weddings with the same sense of style they bring to their everyday lives.”',
        color: 'neutra1',
        backgroundColor: 'humanaDark6',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
    {
      image: {
        url: 'rachel zoe/val-props-carousel/2-registry/glasses.jpg',
      },
      sm: {
        width: 436,
        height: 329,
      },
      belowSm: {
        width: 220,
        height: 166,
      },
    },
    {
      image: {
        url: 'rachel zoe/val-props-carousel/2-registry/rz-book.jpg',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
    {
      circle: true,
      image: {
        url: 'rachel zoe/val-props-carousel/2-registry/living.jpg',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
  ],
  [
    {
      circle: true,
      image: {
        url: 'rachel zoe/val-props-carousel/3-inv/rz-candle.jpg',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
    {
      image: {
        url: 'rachel zoe/val-props-carousel/3-inv/rz-leaves.jpg',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
    {
      image: {
        url: 'rachel zoe/val-props-carousel/3-inv/dress.jpg',
      },
      sm: {
        width: 436,
        height: 329,
      },
      belowSm: {
        width: 220,
        height: 166,
      },
    },
    {
      text: {
        content: '“It’s been a dream working with Joy on this partnership”',
        color: 'neutra1',
        backgroundColor: 'humanaDark6',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
    {
      image: {
        url: 'rachel zoe/val-props-carousel/3-inv/rz-curateur.jpg',
      },
      sm: {
        width: 436,
        height: 329,
      },
      belowSm: {
        width: 220,
        height: 166,
      },
    },
    {
      circle: true,
      text: {
        content: '“Planning a wedding is such an exciting and wonderful process.”',
        color: 'neutra6',
        backgroundColor: 'humana1',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
  ],
  [
    {
      circle: true,
      text: {
        content: '“Planning a wedding is such an exciting and wonderful process.”',
        color: 'neutra6',
        backgroundColor: 'humana1',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
    {
      circle: true,
      image: {
        url: 'rachel zoe/val-props-carousel/4-ww/rz.jpg',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
    {
      text: {
        content: '“I’m thrilled to have teamed up with Joy to help bring a stylish touch to all couples’ weddings.”',
        color: 'neutra1',
        backgroundColor: 'humanaDark6',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
    {
      image: {
        url: 'rachel zoe/val-props-carousel/4-ww/rz-stairs.jpg',
      },
      sm: {
        width: 436,
        height: 436,
      },
      belowSm: {
        width: 220,
        height: 220,
      },
    },
    {
      image: {
        url: 'rachel zoe/val-props-carousel/4-ww/rz-models.jpg',
      },
      sm: {
        width: 436,
        height: 329,
      },
      belowSm: {
        width: 220,
        height: 166,
      },
    },
    {
      image: {
        url: 'rachel zoe/val-props-carousel/4-ww/dress.jpg',
      },
      sm: {
        width: 436,
        height: 329,
      },
      belowSm: {
        width: 220,
        height: 166,
      },
    },
  ],
];

const allImages: CloudImageRowProps = [];
groupImages.map(groupImage => groupImage.map(image => allImages.push(image)));

export const allGroupImages = allImages;
